<template>
  <v-menu :close-on-content-click="false" open-on-click>
    <template #activator="{ props }">
      <v-btn plain v-bind="props" class="d-flex align-center">
        <v-icon>{{ mdiAccount }}</v-icon>
        <span class="ml-2">{{ securityStore.username }}</span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item dense @click="openAccountSettingsDialog">
        <div>
          <v-icon class="mr-2">{{ mdiAccountCog }}</v-icon>
          <span>Personal settings</span>
        </div>
      </v-list-item>
      <v-list-item dense class="checkbox">
        <div>
          <v-checkbox-btn v-model="useDarkTheme" label="Dark theme" hide-details @update:model-value="onThemeToggle" />
        </div>
      </v-list-item>
      <v-list-item dense @click="logout">
        <div>
          <v-icon class="mr-2">{{ mdiLogout }}</v-icon>
          <span>Logout</span>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
  <dialog-personal-settings v-model="showAccountSettingsDialog" />
</template>

<script lang="ts" setup>
import { mdiAccount, mdiLogout, mdiAccountCog } from '@mdi/js'

const securityStore = useSecurityStore()
const showAccountSettingsDialog = ref(false)
const useDarkTheme = ref(false)
const themeStore = useThemeStore()

function onThemeToggle(newValue: boolean) {
  useDarkTheme.value = newValue
  themeStore.updateLocalTheme(newValue ? 'dark' : 'light')
}

function logout() {
  securityStore.unload()
  navigateTo('/login')
}

function openAccountSettingsDialog() {
  showAccountSettingsDialog.value = true
}

onMounted(() => {
  useDarkTheme.value = themeStore.useDarkTheme
})
</script>

<style lang="css">
.checkbox{
  margin-left: -10px;
}
</style>
